import { render, staticRenderFns } from "./StudioMyApps.vue?vue&type=template&id=42d20d45"
import script from "./StudioMyApps.vue?vue&type=script&lang=js"
export * from "./StudioMyApps.vue?vue&type=script&lang=js"
import style0 from "./StudioMyApps.vue?vue&type=style&index=0&id=42d20d45&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports